import classnames from 'classnames'
import React from 'react'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'
import './MultiSelectComponent.css'
import Button from '@mui/material/Button';
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFMember, CFValue} from 'module/CustomField/type/CFType'
import {useCFAttrTextAlignCSS} from 'module/CustomField/style/CFAlignmentStyle'

export interface MultiSelectOption<T> {
	value: T
	displayName: string
	isButton?: boolean
}

export interface MultiSelectComponentProps<T extends CFMember | CFValue> extends CFComponentProps<T> {
	options: MultiSelectOption<T>[]
	vertical?: boolean
}

export function MultiSelectComponent<T extends CFMember | CFValue>({rawValue, disabled, options, setCb, cfDef, vertical = false}: MultiSelectComponentProps<T>) {
	return (
		<div
			css={useCFAttrTextAlignCSS(cfDef)}
			className={classnames('MultiSelectComponent', {
				horizontal: !vertical,
				vertical,
			})}
		>
			{options.map((o, key) => {
				const onClick = () => !disabled && setCb(o.value);
				const selected = rawValue == o.value
				if (!o.isButton) {
					return (
						<FormControlLabel
							key={key}
							control={<Radio color={'primary'} checked={selected}/>}
							label={o.displayName}
							disabled={disabled}
							onClick={onClick}
						/>
					)
				} else {
					return (
						<Button
							key={key}
							disabled={disabled}
							onClick={onClick}
							variant={selected ? 'contained' : 'text'}
							color={selected ? 'primary' : undefined}
						>
							{o.displayName}
						</Button>
					)
				}
			})}
		</div>
	);
}